<template>
  <div id="organization">
    <div class="left-store-nav">
      <el-scrollbar>
        <el-tree
          ref="tree"
          :default-expanded-keys="[selecTree]"
          :current-node-key="selecTree"
          node-key="id"
          class="tree-list"
          highlight-current
          accordion
          :data="organizationData"
          :expand-on-click-node="true"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :render-content="testContent"
        >
        </el-tree>
      </el-scrollbar>
    </div>
    <div class="right-store-list">
      <div style="margin:0 24px;">
        <div class="table_searchbar">
          <el-row style="margin-left:20px">
            <el-col :span="6">
              <div class="" @keydown.enter="btnSearch()">
                <span class="title" style="width: 90px;margin-left: -20px;">手机号/账号： </span>
                <el-input style="max-width:180px" size="small" v-model="searchForm.accountName" maxlength="16" placeholder="手机号/账号"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="" @keydown.enter="btnSearch()">
                <span class="title">姓名：</span>
                <el-input style="max-width:180px" size="small" v-model="searchForm.name" maxlength="16" placeholder="姓名"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="" @keydown.enter="btnSearch()">
                <span class="title">工号：</span>
                <el-input style="max-width:180px" size="small" v-model="searchForm.employeeId" maxlength="16" placeholder="工号"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="text-align:right">
                <el-button icon="el-icon-search" size="mini" type="primary" @click="btnSearch()">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="clearSearch">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-table :data="tableData" style="width: 100%" class="deviceTable">
          <el-table-column prop="name" label="姓名" show-overflow-tooltip min-width="80"></el-table-column>
          <el-table-column prop="employeeId" label="工号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="vendor" label="分厂/机组/供应商" min-width="110" show-overflow-tooltip></el-table-column>
          <el-table-column prop="groupName" label="部门" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="job" label="职位" show-overflow-tooltip min-width="60"></el-table-column>
          <el-table-column prop="roleName" label="角色" show-overflow-tooltip min-width="60"></el-table-column>
          <el-table-column prop="sex" :formatter="parseSex" label="性别" min-width="30"></el-table-column>
          <el-table-column prop="nation" label="民族" show-overflow-tooltip min-width="40"></el-table-column>
          <el-table-column prop="birthday" :formatter="parseDate" label="生日" show-overflow-tooltip min-width="60"></el-table-column>
          <el-table-column prop="workingState" :formatter="parseStatus" label="状态" min-width="40" show-overflow-tooltip></el-table-column>
          <el-table-column prop="isOrgLeader" :formatter="parseLeader" label="部门负责人" show-overflow-tooltip width="120">
            <template slot-scope="scope">
              <!-- <i v-if="scope.row.isOrgLeader" class="el-icon-check"></i> -->
              <span v-if="scope.row.isOrgLeader" style="color:#67C23A;margin-left: 10px;">√</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page" v-if="tableData.length > 0">
          <div class="total_page">
            <span> 共{{ tableTotalPage }}条 10条/页</span>
          </div>
          <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
            <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"> </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增组织开始 -->
    <el-dialog title="新增组织" @close="cancelAddDialog" :visible.sync="addDialogVisible" :width="span == 5 ? '26%' : '33%'" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
        <el-row :gutter="20">
          <el-col :offset="4" :span="18">
            <div class="">
              <span class="title">组织名称：</span>
              <el-form-item prop="name" class="value" style="display:inline-block">
                <el-input ref="focusinput" v-model="addForm.name" placeholder="请输入新增组织名称" maxlength="16"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAdd">确 定</el-button>
        <el-button @click="cancelAddDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 新增组织结束 -->

    <!-- 编辑组织开始 -->
    <el-dialog title="编辑组织" @close="cancelEditDialog" :visible.sync="eidtDialogVisible" :width="span == 5 ? '26%' : '33%'" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="edit" style="width:100%;" class="add_form">
        <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
          <el-row :gutter="20">
            <el-col :offset="4" :span="18">
              <div class="">
                <span class="title">原始名称：</span>
                <span class="value">{{ addForm.oldName }}</span>
                <!-- <el-form-item prop="name" class="value"  style="display:inline-block">
                                    <el-input v-model="addForm.name" placeholder="请输入新增组织名称" maxlength="16"></el-input>
                                </el-form-item> -->
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :offset="4" :span="18">
              <div class="">
                <span class="title">修改名称：</span>
                <el-form-item prop="newName" class="value" style="display:inline-block">
                  <el-input v-model="addForm.newName" placeholder="请输入修改组织名称" maxlength="16"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEdit">确 定</el-button>
        <el-button @click="cancelEditDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑组织结束 -->
  </div>
</template>

<script>
export default {
  name: "OrganizationConf",
  data() {
    let that = this;
    return {
      fristLoad: false,
      organizationData: [],
      selectId: 0,
      defaultProps: {
        children: "sonList",
        label: "name"
      },
      addForm: {
        name: ""
      },
      addDialogVisible: false,
      eidtDialogVisible: false,
      nodeClick: 1,
      searchList: [],
      W: false,
      selecTree: 1,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchFormTemp: "", //临时搜索数据
      searchForm: {
        accountName: null,
        name: null,
        employeeId: null
      },
      rules: {
        name: [{ required: true, message: "请输入组织名称", trigger: "blur" }],
        newName: [
          { required: true, message: "请输入修改组织名称", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value == that.addForm.oldName) {
                callback(new Error("修改名称和原始名称一致"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      tableData: [],
      tableCurrentPage: 1,
      tableTotalPage: 5,
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  mounted: async function() {
    await this.loadOrganizationData();

    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
    this.initTable();
  },
  computed: {
    span() {
      return this.W ? 5 : 7;
    }
  },
  methods: {
    parseStatus(rowData) {
      let status = rowData.workingState;
      let str = "";
      switch (status) {
        case 0:
          str = "在职";
          break;
        case 1:
          str = "休假";
          break;
        case 2:
          str = "离职";
          break;
      }
      return str;
    },
    async loadOrganizationData(id) {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/organization/getOrgTree",
        type: "sync",
        params: {}
      });
      if (res.code == 0) {
        this.organizationData = res.data;
        if (id) {
          this.selectId = id;
          this.selecTree = id;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(id);
          });
        } else {
          if (res.data[0] && res.data[0].sonList && res.data[0].sonList.length > 0) {
            this.selecTree = res.data[0].sonList[0].id;
          }
          this.selectId = res.data[0].id;
        }
      } else {
        this.$message.error(res.msg || res.message);
      }
    },
    parseSex: function(val) {
      if (val.sex == 0) {
        return "女";
      } else {
        return "男";
      }
    },
    parseDate: function(rowData) {
      if (rowData.birthday != null) {
        let dateString = commonUtils.timestampToDate(rowData.birthday, true);
        return dateString;
      }
    },
    parseLeader(rowData) {
      if (rowData.isOrgLeader) {
        return "是";
      }
    },
    submitAdd() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          let params = {};
          params.name = this.addForm.name;
          params.parentId = this.addForm.parentId;
          this.$RequestUtil.post({
            url: "/api/organization/addOrg",
            type: "sync",
            params,
            success: async res => {
              if (res.code == 0) {
                this.$message.success("添加成功");
                this.cancelAddDialog();
                await this.loadOrganizationData(res.data);
                this.$store.commit("add_reloadPages", ["/MasterData/DeviceMgt"]);
                this.btnPressType = 1;
                this.search();
              } else {
                this.$message.error(res.msg || res.message);
              }
            }
          });
        }
      });
    },

    testContent(h, { node, data, store }) {
      let html = null;
      let add = null,
        edit = null,
        close = null;
      if (data.layer == undefined) {
        data.layer = 0;
      }
      if (this.permission.btn_org_add && data.layer < 4) {
        add = <img src="../../static/img/add.png" style="margin-right: 8px; width:14px" on-click={() => this.add(data)} />;
      } else {
        add = <span style="margin-left:18px"></span>;
      }
      if (this.permission.btn_org_update) {
        edit = <img src="../../static/img/edit.png" style="margin-right: 8px;" on-click={() => this.edit(data)} />;
      } else {
        edit = <span style="margin-left:18px"></span>;
      }
      if (this.permission.btn_org_delete) {
        close = <img src="../../static/img/close.png" style="margin-right: 4px;" on-click={() => this.delete(data)} />;
      } else {
        close = <span style="margin-left:18px"></span>;
      }

      let widthData = ["180px", "160px", "140px", "120px", "100px", "80px", "60px"];
      let styleJson = {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: "14px",
        paddingRight: "8px"
      };

      if (data.layer == -1) {
        html = (
          <span title={data.name} style={styleJson}>
            <span>
              <span class="show-ellipsis" style={{ width: `${widthData[data.layer + 1]}`, display: "inline-block" }}>
                {data.name}
              </span>
            </span>
            <span>
              {add}
              {edit}
              <span style="margin-left:18px"></span>
            </span>
          </span>
        );
      } else {
        html = (
          <span title={data.name} style={styleJson}>
            <span>
              <span class="show-ellipsis" style={{ width: `${widthData[data.layer + 1]}`, display: "inline-block" }}>
                {data.name}
              </span>
            </span>
            <span>
              {add}
              {edit}
              {close}
            </span>
          </span>
        );
      }

      return html;
    },

    edit(data) {
      this.nodeClick++;
      this.eidtDialogVisible = true;
      this.addForm.oldName = data.name;
      this.addForm.id = data.id;
    },
    submitEdit() {
      this.$refs["edit"].validate(valid => {
        if (valid) {
          let params = {};
          params.id = this.addForm.id;
          params.name = this.addForm.newName;
          this.$RequestUtil.post({
            url: "/api/organization/updateOrg",
            type: "sync",
            params,
            success: res => {
              if (res.code == 0) {
                this.$message.success("修改成功");
                this.$store.commit("add_reloadPages", ["/MasterData/DeviceMgt"]);
                this.loadOrganizationData(this.addForm.id);
                this.cancelEditDialog();
              } else {
                //damon 解决bug-3969，无提示的问题，因为返回的字段是message
                this.$message.error(res.msg || res.message);
              }
            }
          });
        }
      });
    },
    cancelEditDialog() {
      this.eidtDialogVisible = false;
      this.addForm = {
        name: null,
        parentId: null,
        id: null,
        oldName: null,
        newName: null
      };
      this.editData = {};
    },
    async isUse(id) {
      //删除前检测是否被指派到维修部门
      let res = await this.$RequestUtil.getAsync({ url: "/api/organization/checkOrgInMaintantenceCycle", params: { id } });
      log(res);
      return res.data;
    },

    delete(data) {
      this.nodeClick++;
      this.$confirm(`确认删除该组织节点吗?`, "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let use = await this.isUse(data.id);
        log(use);
        if (use) {
          this.$confirm(`当前组织节点或子节点被指派为维保部门,删除后将清空对应维保工单部门数据,是否继续?`, "提示", {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$RequestUtil.get({
              url: "/api/organization/deleteOrg",
              type: "sync",
              params: {
                id: data.id
              },
              success: res => {
                if (res.code == 0) {
                  this.$message.success("删除成功");
                  this.loadOrganizationData(data.parentId);
                  this.$store.commit("add_reloadPages", ["/MasterData/DeviceMgt"]);
                } else {
                  this.$message.error(res.msg);
                }
              }
            });
          });
        } else {
          this.$RequestUtil.get({
            url: "/api/organization/deleteOrg",
            type: "sync",
            params: {
              id: data.id
            },
            success: res => {
              if (res.code == 0) {
                this.$message.success("删除成功");
                this.loadOrganizationData(data.parentId);
                this.$store.commit("add_reloadPages", ["/MasterData/DeviceMgt"]);
              } else {
                this.$message.error(res.msg);
              }
            }
          });
        }
      });
    },

    cancelAddDialog() {
      this.addDialogVisible = false;
      this.addForm = {
        name: null,
        parentId: null,
        id: null,
        oldName: null,
        newName: null
      };
    },
    add(data) {
      this.nodeClick++;
      this.addDialogVisible = true;
      this.addForm.parentId = data.id;
      setTimeout(() => {
        this.$refs.focusinput.focus();
      }, 0);
    },
    handleNodeClick(ev) {
      this.selectId = ev.id;
      // 当点击编辑和删除的时候nodeClick++阻止节点click事件执行
      if (this.nodeClick > 1) {
        this.nodeClick = 1;
        return;
      }
      this.btnPressType = 1;
      this.tableCurrentPage = 1;
      this.search();
    },

    btnSearch: function() {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;
      this.search();
    },
    clearSearch() {
      let form = this.searchForm;
      this.btnPressType = 2;
      form.accountName = null;
      form.name = null;
      form.employeeId = null;
    },
    search: function() {
      let temp;
      switch (this.btnPressType) {
        case 1:
          temp = commonUtils.cloneObj(this.searchForm);
          this.searchFormTemp = commonUtils.cloneObj(temp);
          break;
        case 0:
          temp = {
            accountName: null,
            name: null,
            employeeId: null
          };
          break;
        case 2:
          temp = this.searchFormTemp;
          break;
        case 3:
          temp = this.searchFormTemp;
          break;
      }
      this.$RequestUtil.get({
        url: "/api/organization/listUser",
        type: "sync",
        params: {
          pageNum: this.tableCurrentPage,
          pageSize: 10,
          groupId: this.selectId,
          accountName: temp.accountName,
          name: temp.name,
          employeeId: temp.employeeId
        },
        success: res => {
          if (res.code == 0) {
            this.tableData = res.data;
            this.tableTotalPage = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },
    pageChange: function(targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },
    initTable: function() {
      this.search();
    }
  }
};
</script>
<style scoped>
.show-ellipsis {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#organization {
  background: #f6f7fa;
  display: flex;
  margin-left: -8px;
  margin-top: -20px;
}
.left-store-nav {
  width: 240px;
  margin-right: 16px;
  background: #fff;
  padding-top: 20px;
}

.left-store-nav .tree-list {
  width: 220px;
  margin: 0 10px;
}

@media screen and (min-width: 1900px) {
  #organization {
    height: 791px;
    width: 102.7%;
  }
  .left-store-nav {
    width: 400px;
  }
  .left-store-nav .tree-list {
    width: 380px;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1800px) {
  #organization {
    height: 778px;
    width: 103.7%;
  }
  .left-store-nav {
    width: 300px;
  }
  .left-store-nav .tree-list {
    width: 280px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1399px) {
  #organization {
    height: 750px;
    width: 104%;
    padding-bottom: 16px;
  }
  .left-store-nav {
    width: 280px;
  }
  .left-store-nav .tree-list {
    width: 260px;
  }
}

.right-store-list {
  width: 100%;
  background: #fff;
  height: 100%;
}

#organization .title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  display: inline-block;
  width: 70px;
  text-align: right;
}
#organization .value {
  width: 188px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.table_searchbar {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.import_upload {
  display: inline;
}
.page {
  display: flex;
  justify-content: flex-end;
}
@media screen and (max-width: 1450px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}
.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
.delete {
  width: 18px;
  height: 19px;
  background-image: url("../../../static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}
.delete:hover {
  background-image: url("../../../static/img/del-hover.png");
  background-repeat: no-repeat;
}
</style>
<style>
.show-ellipsis {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.table_searchbar .el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}
.timer .el-time-panel {
  width: 140px;
  left: 6px;
}
@media screen and (min-width: 1900px) {
  #organization .left-store-nav .el-scrollbar__wrap {
    overflow-x: hidden;
    height: 700px;
    overflow-x: hidden;
    margin-bottom: 0px !important;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1800px) {
  #organization .left-store-nav .el-scrollbar__wrap {
    overflow-x: hidden;
    height: 680px;
    overflow-x: hidden;
    margin-bottom: 0px !important;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1399px) {
  #organization .left-store-nav .el-scrollbar__wrap {
    overflow-x: hidden;
    height: 600px;
    overflow-x: hidden;
    margin-bottom: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Organization/OrganizationConf.vue